
<template>
  <div>
    <CompanyCommissionRecord :isReport="true"></CompanyCommissionRecord>
  </div>
</template>
<script type="text/javascript">
import CompanyCommissionRecord from '@/Adm/CompanyCommission/CompanyCommissionRecord'
  export default{
    name: 'ReportSr',
    components:{
      CompanyCommissionRecord
    }
  }
</script>


// WEBPACK FOOTER //
// src/Dw/containers/ReportCompanyCommission.vue